<template>

  <section class="login">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="content-wrapper d-flex align-items-center auth">
          <div class="row w-100 flex-grow">
            <div class="col-xl-4 col-lg-6 mx-auto">
              <div class="auth-form-light text-left p-5">
                <div class="brand-logo">
                 Kindy - Kunden
                </div>
                <div v-if="errorMessage" role="alert" aria-live="polite" aria-atomic="true" class="alert alert-info">{{errorMessage}}</div>
                <form class="pt-3">
                  <div class="form-group">
                    <input type="email" v-model="formEmail" class="form-control form-control-lg" id="exampleInputEmail1" placeholder="E-Mail">
                  </div>
                  <div class="form-group">
                    <input type="password" v-model="formPwd" class="form-control form-control-lg" id="exampleInputPassword1" placeholder="Passwort">
                  </div> 
                  <div class="mt-3">
                    <button @click="login($event)" class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn" to="/">EINLOGGEN</button>
                  </div>
                 
            
             
                </form>
              </div>
            </div>
          </div>
      </div>
      <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>

</template>

<script>

import axios from 'axios';
import { doLogin } from '@/services/login.service';  

export default {
  name: 'login',

  data () {
    return {

      formEmail: "",
      formPwd: "",
      error: false,
      errorMessage: "",
     
    }
  },
  methods: {

    login: function (ev) {

      if (ev) {
        ev.preventDefault()
      }
      this.error = false

      this.$store.commit('auth_request')

    

      doLogin({ email: this.formEmail, password:  this.formPwd }).then( x => {

        if (x.status == 'error') {
          this.error = true
          this.errorMessage = x.message
          this.$store.commit('auth_error')
          localStorage.removeItem('token')
        } else {
          const token = x.data.token
          const user = x.data.user
          localStorage.setItem('token', token)
          axios.defaults.headers.common['x-access-token'] = token

          this.$store.commit('auth_success', {token, user})
          this.$router.push({ name: 'dashboard' }) 
        }
      
      })
    },
    keyUp: function (ev) {
      if (ev.keyCode == 13) {
        this.login()
      }
    }
    
  },
  mounted() {

     
  }



}
</script>
